/**
 * Portfolio 类型定义
 */

/**
 * Portfolio 类型枚举
 */
export enum PortfolioType {
  /** Watchlist 类型 - 用户手动添加的资产收藏 */
  WATCHLIST = "watchlist",
  /** 外部导入类型 - 从外部平台导入的资产 */
  EXTERNAL = "external",
}
